// frontend/src/components/admin/UserForm.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const UserForm = ({ open, handleClose, onSave, editingUser }) => {
  // On remet l'état initial complet avec tous tes champs
  const getInitialFormData = () => ({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "participant",
    phone: "",
    profession: "",
    professionOther: "",
    grade: "",
    studentLevel: "",
    institution: "",
  });

  const [formData, setFormData] = useState(getInitialFormData());
  const roles = ["participant", "workshop_leader", "admin"];

  // Le useEffect continue de faire sa magie, mais maintenant pour tous les champs !
  useEffect(() => {
    if (editingUser) {
      // Mode modification : on remplit tout
      setFormData({
        firstName: editingUser.firstName || "",
        lastName: editingUser.lastName || "",
        email: editingUser.email || "",
        password: "", // Toujours vide par sécurité
        role: editingUser.role || "participant",
        phone: editingUser.phone || "",
        profession: editingUser.profession || "",
        professionOther: editingUser.professionOther || "",
        grade: editingUser.grade || "",
        studentLevel: editingUser.studentLevel || "",
        institution: editingUser.institution || "",
      });
    } else {
      // Mode création : on réinitialise tout
      setFormData(getInitialFormData());
    }
  }, [editingUser, open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onSave(formData, editingUser?._id);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      {/* Le titre est toujours dynamique */}
      <DialogTitle>
        {editingUser ? "Modifier l'Utilisateur" : "Créer un Nouvel Utilisateur"}
      </DialogTitle>
      <DialogContent>
        {/* Et voici le retour de ton formulaire complet ! */}
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Prénom"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Nom"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required={!editingUser}
              fullWidth
              label={
                editingUser
                  ? "Nouveau mot de passe (optionnel)"
                  : "Mot de passe"
              }
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth required>
              <InputLabel>Rôle</InputLabel>
              <Select
                name="role"
                value={formData.role}
                label="Rôle"
                onChange={handleChange}
              >
                {roles.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role.replace("_", " ")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Numéro de Téléphone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel>Profession</InputLabel>
              <Select
                name="profession"
                value={formData.profession}
                label="Profession"
                onChange={handleChange}
              >
                <MenuItem value="Etudiant">Étudiant</MenuItem>
                <MenuItem value="Enseignant">Enseignant</MenuItem>
                <MenuItem value="Autre">Autre</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Et le retour des champs conditionnels ! */}
          {formData.profession === "Autre" && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Veuillez préciser"
                name="professionOther"
                value={formData.professionOther}
                onChange={handleChange}
              />
            </Grid>
          )}
          {formData.profession === "Etudiant" && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Niveau d'études"
                  name="studentLevel"
                  value={formData.studentLevel}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Établissement"
                  name="institution"
                  value={formData.institution}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}
          {formData.profession === "Enseignant" && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Grade"
                  name="grade"
                  value={formData.grade}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Établissement"
                  name="institution"
                  value={formData.institution}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={handleSubmit} variant="contained">
          {editingUser ? "Modifier" : "Créer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
